
import { OrderTreatmentProps, TreatmentOrderModalProps } from "./types";
import { FC, useContext, useEffect } from "react";
// import { CreateOrderAPIResponse, CreateOrderErrorResponse, CreateOrderModalProps, CreateOrderProps } from "./types";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import HubInputField from "src/components/inputType";
import { GroupBase, OptionsOrGroups } from "react-select";
import { CreateOrderAPIResponse } from "../createOrderModal/types";
import { OrderTreatmentSchema } from "src/validation/OrderTreatment";

const TreatmentOrderModal: FC<TreatmentOrderModalProps> = ({ isModalVisible, patientName, hideModal, orderType,refreshListing }): JSX.Element => {
  const { control, handleSubmit,setValue ,reset} = useForm<OrderTreatmentProps>({
    mode: 'all',
    resolver: yupResolver(OrderTreatmentSchema)
  });
  const { showToast } = useContext(ToastContext);
  const {  hideLoader } = useContext(LoaderContext);
  const { data: creatOrderResponseData, mutate: createOrder, error: createOrderError } =
    useFetch<CreateOrderAPIResponse>(APIEndpoints.CREATE_ORDER);
  const clickOnCreateOrder = (values: OrderTreatmentProps) => {
    const requestBody = {
      "order_type": values.order_type,
      "po_number": values.po_number,
    }
    createOrder(requestBody)
  }
  useEffect(() => {
    setValue("order_type",orderType && orderType.length>0 ? orderType[0].type : " ")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderType]);

  useEffect(() => {
    if (creatOrderResponseData || createOrderError) {
      hideLoader();
      reset();
      hideModal();
      if(creatOrderResponseData){
        showToast([`Order Created Successfully`], ToastTypes.SUCCESS);
        refreshListing();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creatOrderResponseData, createOrderError]);

  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      id="exampleModal"
      tabIndex={-1}
      data-bs-backdrop="true"
      aria-hidden="true"
      onClick={hideModal}
    >
      <form onSubmit={handleSubmit(clickOnCreateOrder)}>
        <div className="modal-dialog modal-lg" onClick={e => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header">
              <p className="modal-title fs-3 text-primary" id="exampleModalLabel">
                Order Product for {patientName}
              </p>
              <button type="button" className="btn-close" aria-label="Close" onClick={hideModal}></button>
            </div>

            <div className="modal-body">
              <p> Input information in the form below to place your order </p>


              <div className="row align-items-center mb-3">
                <div className="col-3">
                  <p className="mb-0 text-end"> Order Type * </p>
                </div>

                <div className="col-7">
                  <Controller
                    name="order_type"
                    control={control}
                    defaultValue=""
                    render={({ field, fieldState: { error } }) => (
                      <HubInputField
                        inputId="order_type"
                        isRowBased={true}
                        isRequired={false}
                        field={field}
                        isDropdown={true}
                        isSearchable={false}
                        dropdownData={orderType.map(({ name, type }) => ({ label: name, value: type })) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                        error={error}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="row align-items-center mb-3">
                <div className="col-3">
                  <p className="mb-0 text-end"> PO Number  </p>
                </div>

                <div className="col-7">
                  <Controller
                    name="po_number"
                    control={control}
                    defaultValue=""
                    render={({ field, fieldState: { error } }) => (
                      <HubInputField
                        inputId="po_number"
                        isRequired={true}
                        isRowBased={true}
                        field={field}
                        error={error}
                        inputPlaceholder="PO Number"
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-start">
              <button type="submit" className="btn btn-primary" data-bs-dismiss="modal" >
                Order
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};


export default TreatmentOrderModal;
